import { Button, Modal } from "antd";
import SucessImg from "assets/green_check.svg";
import RejectImg from "../../../../assets/red_cross.svg";
type ActionModalProps = {
  open: boolean;
  actionType: 'Approve' | 'Reject';
  onConfirm: () => void;
  onCancel: () => void;
};

export const ActionModal = ({
  open,
  actionType,
  onConfirm,
  onCancel,
}: ActionModalProps) => {
  const isApprove = actionType === 'Approve';

  return (
    <Modal open={open} footer={null} closable={false} centered width={420}>
      <div style={{ textAlign: "center", padding: "10px 0" }}>
        
         <img
          src={isApprove ? SucessImg : RejectImg}
          alt="status"
          style={{ width: 80, marginBottom: 16 }}
        />

        <div style={{ fontSize: "20px", fontWeight: 600, marginBottom: "10px" }}>
          {isApprove ? "Approve Request!" : "Reject Request!"}
        </div>

        <div style={{ color: "#555", fontSize: "14px", marginBottom: "20px" }}>
          Are you sure you want to {actionType.toLowerCase()}?
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
          <Button onClick={onCancel}>No</Button>

          <Button
            type="primary"
            onClick={onConfirm}
            style={{
              backgroundColor: isApprove ? "#cf0bcf" : "#8f0a0a",
              borderColor: isApprove ? "#cf0bcf" : "#8f0a0a",
            }}
          >
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};